import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Video, ImageIcon, Sparkles, Download } from "lucide-react";

export function HeroVideoCreator() {
  const steps = [
    {
      number: 1,
      icon: ImageIcon,
      title: "Foto auswählen",
      description: "Wählen Sie ein Bild aus Ihrer Foto-Bibliothek"
    },
    {
      number: 2,
      icon: Sparkles,
      title: "KI erstellt Video",
      description: "Text, Voiceover und Animation in Sekunden"
    },
    {
      number: 3,
      icon: Download,
      title: "Video exportieren",
      description: "Fertig für LinkedIn, Instagram & TikTok"
    }
  ];

  return (
    <Card
      className="border-2 border-purple-500 relative"
      data-testid="card-hero-video-creator"
    >
      <Badge className="absolute top-3 right-3 z-10 bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100">
        Bald verfügbar
      </Badge>
      <CardContent className="pt-6 pb-6 sm:pt-8 sm:pb-8">
        <div className="flex items-start sm:items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
          <Video className="w-6 h-6 sm:w-8 sm:h-8 text-purple-500 flex-shrink-0" />
          <h2 className="text-xl sm:text-2xl font-semibold">
            Vom Foto zum perfekten Video
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-3 mb-6">
          {steps.map((step) => (
            <div key={step.number} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-bold flex-shrink-0">
                {step.number}
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <step.icon className="w-4 h-4 text-purple-500" />
                  <h4 className="font-medium">{step.title}</h4>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed break-words">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-3">
          <Button
            size="lg"
            className="min-h-[44px] bg-purple-600 hover:bg-purple-700"
            disabled
            data-testid="button-create-video"
          >
            <Video className="w-4 h-4 mr-2" aria-hidden="true" />
            Video erstellen
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
